/* eslint-disable eag/match-named-export */
/* tslint:disable */
// this is an auto generated file. This will be overwritten
import * as APITypes from '../API';

type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const healthCheck = /* GraphQL */ `query HealthCheck {
  healthCheck
}
` as GeneratedQuery<APITypes.HealthCheckQueryVariables, APITypes.HealthCheckQuery>;
